import { render, staticRenderFns } from "./VersionListContainer.vue?vue&type=template&id=f5d5bbb8&scoped=true&"
import script from "./VersionListContainer.vue?vue&type=script&lang=js&"
export * from "./VersionListContainer.vue?vue&type=script&lang=js&"
import style0 from "./VersionListContainer.vue?vue&type=style&index=0&id=f5d5bbb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d5bbb8",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VChip,VIcon})
